import YYInputMultiLang from './input-multilang'

export default YYInputMultiLang